import { Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './components/cart/cart-context';
import { MaisonAdjiCartProvider } from './context/MaisonAdjiCartProvider';
import { CurrencySettingsProvider } from './context/CurrencySettingsContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { Navbar } from './components/layout/navbar/index';
import { Toaster } from 'sonner';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import StudioPage from './pages/StudioPage';
import BespokePage from './pages/BespokePage';
import SearchPage from './pages/SearchPage';
import CheckoutPage from './pages/CheckoutPage';
import CheckoutSuccessPage from './pages/CheckoutSuccessPage';
import CheckoutFailedPage from './pages/CheckoutFailedPage';
import CheckoutMaisonAdjiPage from './pages/CheckoutMaisonAdjiPage';
import ShippingPage from './pages/ShippingPage';
import PaymentPage from './pages/PaymentPage';
import LoginPage from './pages/LoginPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import DocumentaryPage from './pages/DocumentaryPage';
import PressPage from './pages/PressPage';
import MyOrdersPage from './pages/MyOrdersPage';
import MyProfilePage from './pages/MyProfilePage';
import BusinessDashboardPage from './pages/BusinessDashboardPage';
import './index.css';

function AppContent() {
  const location = useLocation();
  
  const isCheckout = location.pathname.startsWith('/checkout') || location.pathname.startsWith('/shipping') || location.pathname.startsWith('/payment');
  const isLogin = location.pathname === '/login';

  return (
    <div className="bg-neutral-950 text-white selection:bg-white/20">
      {!isCheckout && !isLogin && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/product/:handle" element={<ProductPage />} />
          <Route path="/studio" element={<StudioPage />} />
          <Route path="/bespoke" element={<BespokePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/documentary" element={<DocumentaryPage />} />
          <Route path="/press" element={<PressPage />} />
          <Route path="/mes-commandes" element={<MyOrdersPage />} />
          <Route path="/mon-profil" element={<MyProfilePage />} />
          <Route path="/espace-business" element={<BusinessDashboardPage />} />
          <Route path="/espace-business/products/edit/:productId" element={<BusinessDashboardPage />} />
          <Route path="/espace-business/:section" element={<BusinessDashboardPage />} />
          <Route path="/collections" element={<SearchPage />} />
          <Route path="/collections/:collection" element={<SearchPage />} />
          <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
          <Route path="/checkout/failed" element={<CheckoutFailedPage />} />
          <Route path="/checkout-maison-adji" element={<CheckoutMaisonAdjiPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/shipping" element={<ShippingPage />} />
          <Route path="/payment" element={<PaymentPage />} />
        </Routes>
        <Toaster closeButton />
      </main>
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <AuthProvider>
          <CartProvider>
            <CurrencySettingsProvider>
              <MaisonAdjiCartProvider>
                <AppContent />
              </MaisonAdjiCartProvider>
            </CurrencySettingsProvider>
          </CartProvider>
        </AuthProvider>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;

